import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ThumbnailState, ThumbnailViewModel } from '@/types';

export const state: ThumbnailState = {
  thumbnails: [] as ThumbnailViewModel[]
};

const namespaced: boolean = true;

export const thumbnails = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
